import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AccountContext } from '../../../../components/AccountContext';
import SuperMatchContactRequest from './SuperMatchContactRequest';
import { Button } from 'primereact/button';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { Loading } from '../../../../components/Loading';

const GENERATE_SUPER_MATCH_REPORT = gql`
  mutation generateSuperMatchReportMutation($input: SuperMatchReportInput!) {
    generateSuperMatchReport(input: $input) {
      url
    }
  }
`;

const SuperMatchListEntry = ({ superMatch, requestContact }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [generateSuperMatchReportMutation, { loading }] = useMutation(GENERATE_SUPER_MATCH_REPORT);

  const generateSuperMatchReport = async () => {
    try {
      const {
        data: {
          generateSuperMatchReport: { url },
        },
      } = await generateSuperMatchReportMutation({
        variables: {
          input: {
            account: currentAccount,
            superMatch: superMatch.id,
          },
        },
      });

      window.open(url, '_blank', 'noreferrer');
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  return (
    <div key={superMatch.id} className="flex-space-between margin-bottom-1">
      <div>{superMatch.superProfile.publicTitle}</div>
      <div>
        <Link to={`/accounts/${currentAccount}/super-matches/${superMatch.id}`} className="app-link">
          {superMatch.superProfile.jobProfile.name}
        </Link>
      </div>
      <div>{`${superMatch.assessmentMatchPercentage}%`}</div>
      <div>{`${superMatch.qAndRMatchPercentage}%`}</div>
      <div>{`${superMatch.respondent.firstName} ${superMatch.respondent.lastName}`}</div>
      <div>{`${superMatch.respondent.contactSuccessRate}%`}</div>
      <div>
        <SuperMatchContactRequest superMatch={superMatch} requestContact={requestContact} />
      </div>
      <div>{loading ? <Loading size="small" /> : <Button onClick={generateSuperMatchReport} label="Generate" />}</div>
    </div>
  );
};

export default SuperMatchListEntry;
